module.exports = __webpack_public_path__ + "img/h_mid_3.0160a869.png";